import { withErrorBoundary } from '../dependencies';

import Exports from '../components/Exports';

export default withErrorBoundary(Exports);
